/**
 * Helpers for view-tag-based platform routing.
 *
 * The AE designer agent (in calc-api) uses the same `mobile*` prefix rule to
 * detect mobile-targeted views. Keep these helpers in sync with the equivalent
 * check in `calc-api/apps/agents/src/agents/prompts/aeViewBuilder.js` and
 * `aeViewEditor.js`.
 */

/**
 * @param {string|null|undefined} tagName
 * @returns {boolean} true when the (lowercased) tag name starts with `mobile`.
 */
export function isMobileTag (tagName) {
  return String(tagName ?? '').toLowerCase().startsWith('mobile')
}

/**
 * @param {Array<{name?: string}|string>|null|undefined} tags - tag objects with a `name`, or plain tag-name strings
 * @returns {boolean} true when at least one tag in the array is a `mobile*` tag.
 */
export function viewHasMobileTag (tags) {
  if (!Array.isArray(tags)) return false
  return tags.some((t) => isMobileTag(typeof t === 'string' ? t : t?.name))
}
